
import React from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Card';
import '../cssfiles/cardsgroup.css'
import {CartState} from '../context/contextmen'

function Mens() {

const { dispatch} = CartState();
  const {state: { products }, productState: { sort ,searchQuery} } = CartState();

  const transformProducts = () => {
    let sortedProducts = products;

    if (sort) {
      sortedProducts = sortedProducts.sort((a, b) =>
        sort === "lowToHigh" ? a.price - b.price : b.price - a.price
      );
    }
    if (searchQuery) {
      sortedProducts = sortedProducts.filter((prod) =>
        prod.name.toLowerCase().includes(searchQuery)
      );
      
    }
  
    return sortedProducts;
  }


  

  return (
    <div> <h1 className='heading'>MENS WEAR</h1> 
    
    {
    
    transformProducts().map((item, index)=>{
      item.qty= 1
      return <div className='display'><Card key={index} style={{ width: '18rem' }}  className="cards">
      <Card.Img variant="top" src={ item.Image } alt="PRODUCT" className='imagees'/>
      <Card.Body>
        <Card.Title>{item.name}</Card.Title>
        <Card.Text>
        ${item.price}
        </Card.Text>
        <Card.Text>
        {item.description}
        </Card.Text>
        <Button className='btn btn-primary active' onClick={()=> dispatch({type : 'ADD_TO_CART', payload: item})}>Add to cart</Button>
      </Card.Body>
      </Card></div>
    })}
    </div>
  )
}

export default Mens